import { useCallback } from "react";

import type { ChatStory } from "../types";
import type { GroupedLogs, StatusAction } from "../utils/message-parsers";

import { applyStatusAction } from "../utils/message-parsers";

export function useChatStatusActions(): {
  handleStatusAction: (
    messages: (ChatStory | GroupedLogs)[],
    action: StatusAction,
  ) => (ChatStory | GroupedLogs)[];
} {
  const handleStatusAction = useCallback(
    (
      messages: (ChatStory | GroupedLogs)[],
      action: StatusAction,
    ): (ChatStory | GroupedLogs)[] => {
      try {
        return applyStatusAction(messages, action);
      } catch (error) {
        console.error("Error applying status action:", error, action);

        return messages;
      }
    },
    [],
  );

  return { handleStatusAction };
}
